import React, {
  KeyboardEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Row, Col } from 'react-bootstrap';
import { FaEraser, FaSync } from 'react-icons/fa';
import { InputMoney, InputDate, InputSelect } from '~/components/NovosInputs';
import TableFinanceiro from './TableFinanceiro';
import { useNFOutrasOperacao } from '../../NFOutrasOperacoesContext';
import Separator from '~/components/Separator';
// eslint-disable-next-line import/named
import { ContainerScreens, ButtonItens } from './styles';
import getFinalizadoras from '../../services/getFinalizadoras';
import getCondicoes from '../../services/getCondicoes';
import { formatCurrencyAsText } from '~/utils/functions';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { MdModeEdit } from 'react-icons/md';
import api from '~/services/api';
import { VincularAgendamento } from '~/components/VincularAgendamento';
import { toast } from 'react-toastify';

export type SelectType = {
  value: number | string;
  label: string;
};

export const Finaceiro: React.FC = () => {
  const {
    formStateFinanceiro,
    controlFinanceiro,
    registerFinanceiro,
    setValueFinanceiro,
    setFinalizadoras,
    clearErrorsFinanceiro,
    finalizadoras,
    setCondicoes,
    handleAddParcela,
    onClearFinaceiro,
    updateFinaceiro,
    financeiroCalcular,
    parcelasFinanceiro,
    disable,
    total,
    perfil,
    loja,
    qtdAgendamento,
    fornecedor,
    handleAddParcelaAgendamento,
    setAgendamentos,
    update,
    tipoOperacao,
  } = useNFOutrasOperacao();
  const [categorias, setCategorias] = useState<SelectType[]>([]);
  const [contas, setContas] = useState<SelectType[]>([]);

  const focusInputByName = (inputName: string) => {
    const inputElement = document.querySelector<HTMLInputElement>(
      `input[name="${inputName}"]`,
    );
    if (inputElement) inputElement.focus();
  };

  const arredondarParaDuasCasas = useCallback((valor: number): number => {
    const [, decimais] = valor.toString().split('.');

    if (decimais && decimais.length > 2) return Math.round(valor * 100) / 100;
    return valor;
  }, []);

  useEffect(() => {
    (async () => {
      const optionsFinalizadora = await getFinalizadoras();
      setFinalizadoras(optionsFinalizadora);

      const optionsCondicao = await getCondicoes();
      setCondicoes(optionsCondicao);
    })();
  }, []);

  useEffect(() => {
    if (parcelasFinanceiro.length !== 0) {
      const totalParcelas = parcelasFinanceiro.reduce(
        (acc, parcela) => acc + parcela.val_parcela,
        0,
      );
      const resultado = total.Total_Nota_Fiscal - totalParcelas;

      setTimeout(() => {
        setValueFinanceiro(
          'val_financeiro',
          formatCurrencyAsText(
            arredondarParaDuasCasas(resultado > 0 ? resultado : 0),
          ),
        );
      }, 20);
    } else {
      setValueFinanceiro(
        'val_financeiro',
        formatCurrencyAsText(arredondarParaDuasCasas(total.Total_Nota_Fiscal)),
      );
    }
  }, [parcelasFinanceiro, total.Total_Nota_Fiscal, arredondarParaDuasCasas]);

  const refDivBtn = useRef<HTMLDivElement | null>(null);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        event.preventDefault();

        setTimeout(() => {
          if (refDivBtn.current) {
            const btn: HTMLButtonElement | null =
              refDivBtn.current.querySelector('button[type="button"]');
            focusInputByName('dta_vencimento');
            if (btn) btn.click();
          }
        }, 100);
      }
    },
    [],
  );

  // Categorias
  useEffect(() => {
    (async () => {
      if (perfil) {
        const tipo_categoria = perfil.tipo_operacao === 1 ? 0 : 1;
        const { data } = await api.get(
          `/perfil-loja/categorias/${tipo_categoria}`,
        );
        const option = data.data.map((categoria: any) => {
          return {
            value: categoria.cod_categoria,
            label: categoria.descricao,
            ...categoria,
          };
        });

        setCategorias(option);
      }
    })();
  }, [perfil]);

  // Contas
  useEffect(() => {
    (async () => {
      if (loja?.cod_loja) {
        const { data } = await api.get(`/contas/loja/${loja?.cod_loja}`);
        const option = data.data.map((conta: any) => {
          return {
            value: conta.cod_cc,
            label: conta.descricao,
            ...conta,
          };
        });

        setContas(option);
      }
    })();
  }, [loja?.cod_loja]);

  return (
    <ContainerScreens>
      <Row>
        <Col md={update ? 10 : 9} sm={12}>
          <Separator labelText="Financeiro" sidePadding="0 0" />
        </Col>
        <Col md={update ? 2 : 3} sm={12}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ButtonItens
              disabled={disable}
              type="button"
              onClick={() => financeiroCalcular()}
            >
              <FaSync color="#28a745" />
              <span>(Re) Calcular</span>
            </ButtonItens>
            {!update && (
              <div style={{ marginTop: '8px' }}>
                <VincularAgendamento
                  codTela={172}
                  codPessoa={Number(fornecedor?.cod_pessoa || 0)}
                  codLoja={loja?.cod_loja || 1}
                  qtdAgendamento={{
                    pagar: qtdAgendamento.pagar,
                    receber: qtdAgendamento.receber,
                  }}
                  onSuccess={async (agendamentos) => {
                    if (agendamentos.length > 0) {
                      const cods = agendamentos.map((a) => a.cod_finalizadora);
                      const codsUnicos = new Set();
                      const duplicados = cods.filter((cod) => {
                        if (codsUnicos.has(cod)) return true;
                        codsUnicos.add(cod);
                        return false;
                      });

                      if (duplicados.length > 0) {
                        toast.warning(
                          'Existem finalizadoras repetidas nos agendamentos.',
                        );
                        return;
                      }

                      const dataParcela = agendamentos.map((agendamento) => ({
                        categoria: '',
                        cod_finalizadora: {
                          label: `${agendamento.cod_finalizadora} - ${agendamento.des_finalizadora}`,
                          value: agendamento.cod_finalizadora,
                        },
                        condicao: {
                          cod_condicao: 2,
                          des_condicao: 'DIAS DA DATA',
                          des_definicao: 'DD',
                          label: 'DD - DIAS DA DATA',
                          value: 2,
                        },
                        conta: '',
                        dta_vencimento: agendamento.dta_vencimento,
                        num_condicao: 30,
                        val_financeiro: agendamento.val_parcela,
                      }));

                      await Promise.all(
                        dataParcela.map((parcela) =>
                          handleAddParcelaAgendamento(parcela),
                        ),
                      );

                      setAgendamentos(agendamentos);
                    }
                  }}
                  tipoOperacao={tipoOperacao}
                />
              </div>
            )}
          </div>
        </Col>
      </Row>
      <Row style={{ minHeight: '70px', alignItems: 'flex-end' }}>
        <Col md={4} sm={12}>
          <InputSelect
            label="Finalizadora"
            maxLength={50}
            placeholder="Selecione..."
            name="cod_finalizadora"
            disabled={disable}
            register={registerFinanceiro}
            options={finalizadoras}
            isError={!!formStateFinanceiro.errors.cod_finalizadora}
            control={controlFinanceiro}
            changeSelected={(selected: any) => {
              setValueFinanceiro('cod_finalizadora', selected);
            }}
            onKeyDown={handleKeyDown}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputDate
            register={registerFinanceiro}
            label="Vencimento"
            name="dta_vencimento"
            control={controlFinanceiro}
            disabled={disable}
            isError={!!formStateFinanceiro.errors.dta_vencimento}
            onKeyDown={handleKeyDown}
          />
        </Col>
        <Col sm={12} md={2} onKeyDown={handleKeyDown}>
          <InputMoney
            label="Valor"
            placeholder="0,00"
            min={0}
            decimals={2}
            name="val_financeiro"
            disabled={disable}
            register={registerFinanceiro}
            control={controlFinanceiro}
            isError={!!formStateFinanceiro.errors.val_financeiro}
          />
        </Col>
        <Col
          md={2}
          sm={12}
          ref={refDivBtn}
          style={{ display: 'flex', height: '70px', alignItems: 'flex-end' }}
        >
          <CustomButtonNovo
            onClick={async () => {
              await handleAddParcela();
            }}
            label={updateFinaceiro ? 'Editar' : 'Adicionar'}
            icon={updateFinaceiro ? MdModeEdit : IoMdAddCircleOutline}
            disabled={disable}
            variant="confirm"
            width="100%"
          />
        </Col>
        <Col
          md={2}
          sm={12}
          style={{ display: 'flex', height: '70px', alignItems: 'flex-end' }}
        >
          <CustomButtonNovo
            onClick={onClearFinaceiro}
            label="Limpar"
            icon={FaEraser}
            disabled={disable}
            variant="clear"
            width="100%"
          />
        </Col>
      </Row>
      <br />
      <div>
        <TableFinanceiro />
      </div>
      <Row className="d-flex align-items-end">
        <Col sm={12} md={2}>
          <InputSelect
            ListaWidth="580px"
            label="Categoria"
            placeholder="Selecione..."
            name="categoria"
            register={registerFinanceiro}
            isDisabled={disable}
            isError={!!formStateFinanceiro.errors.categoria}
            control={controlFinanceiro}
            options={categorias}
            changeSelected={(selected) => {
              clearErrorsFinanceiro('categoria');
              setValueFinanceiro('categoria', selected);
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputSelect
            ListaWidth="480px"
            label="Conta"
            placeholder="Selecione..."
            name="conta"
            register={registerFinanceiro}
            isDisabled={disable}
            isError={!!formStateFinanceiro.errors.conta}
            control={controlFinanceiro}
            options={contas}
            changeSelected={(selected) => {
              clearErrorsFinanceiro('conta');
              setValueFinanceiro('conta', selected);
            }}
          />
        </Col>
        <Col sm={12} md={8}>
          <h5
            style={{
              textAlign: 'right',
              display: 'block',
              marginTop: '20px',
            }}
          >
            {`Total Financeiro: R$${formatCurrencyAsText(
              parcelasFinanceiro.reduce(
                (sum, { val_parcela }) => sum + val_parcela,
                0,
              ),
            )}`}
          </h5>
        </Col>
      </Row>
    </ContainerScreens>
  );
};
